import { render, staticRenderFns } from "./comprehensiveAnalysis.vue?vue&type=template&id=1dd99488&scoped=true&"
import script from "./comprehensiveAnalysis.vue?vue&type=script&lang=js&"
export * from "./comprehensiveAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./comprehensiveAnalysis.vue?vue&type=style&index=0&id=1dd99488&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd99488",
  null
  
)

export default component.exports